"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractProps = void 0;
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const responsive_js_1 = require("./responsive.js");
const merge_styles_js_1 = require("./merge-styles.js");
function mergePropDefs(...args) {
    return Object.assign({}, ...args);
}
/**
 * Takes props, checks them against prop defs that have a `className` on them,
 * adds necessary CSS classes and inline styles, and returns the props without
 * the corresponding prop defs that were used to formulate the new `className`
 * and `style` values. Also applies prop def defaults to every prop.
 */
function extractProps(props, ...propDefs) {
    let className;
    let style;
    const extractedProps = { ...props };
    const allPropDefs = mergePropDefs(...propDefs);
    for (const key in allPropDefs) {
        let value = extractedProps[key];
        const propDef = allPropDefs[key];
        // Apply prop def defaults
        if (propDef.default !== undefined && value === undefined) {
            value = propDef.default;
        }
        // Apply the default value if the value is not a valid enum value
        if (propDef.type === 'enum') {
            const values = [propDef.default, ...propDef.values];
            if (!values.includes(value) && !(0, responsive_js_1.isResponsiveObject)(value)) {
                value = propDef.default;
            }
        }
        // Apply the value with defaults
        extractedProps[key] = value;
        if ('className' in propDef && propDef.className) {
            delete extractedProps[key];
            const isResponsivePropDef = 'responsive' in propDef;
            // Make sure we are not threading through responsive values for non-responsive prop defs
            if (!value || ((0, responsive_js_1.isResponsiveObject)(value) && !isResponsivePropDef)) {
                continue;
            }
            if (propDef.type === 'enum') {
                const propClassName = (0, responsive_js_1.getResponsiveClassNames)({
                    allowArbitraryValues: false,
                    value,
                    className: propDef.className,
                    propValues: propDef.values,
                    parseValue: propDef.parseValue,
                });
                className = (0, classnames_1.default)(className, propClassName);
                continue;
            }
            if (propDef.type === 'string' || propDef.type === 'enum | string') {
                const propDefValues = propDef.type === 'string' ? [] : propDef.values;
                const [propClassNames, propCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
                    className: propDef.className,
                    customProperties: propDef.customProperties,
                    propValues: propDefValues,
                    parseValue: propDef.parseValue,
                    value,
                });
                style = (0, merge_styles_js_1.mergeStyles)(style, propCustomProperties);
                className = (0, classnames_1.default)(className, propClassNames);
                continue;
            }
            if (propDef.type === 'boolean' && value) {
                // TODO handle responsive boolean props
                className = (0, classnames_1.default)(className, propDef.className);
                continue;
            }
        }
    }
    extractedProps.className = (0, classnames_1.default)(className, props.className);
    extractedProps.style = (0, merge_styles_js_1.mergeStyles)(style, props.style);
    return extractedProps;
}
exports.extractProps = extractProps;
//# sourceMappingURL=extract-props.js.map